import CuentasBancarias from './cuentasbancarias.vue';
import CuentaBancariaForm from './cuentabancaria-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/cuentasbancarias/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('cuentasbancarias', [], CuentasBancarias),
        keepAlive: true
    },
    {
        path: '/cuentasbancarias/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('cuentasbancarias/new', [], CuentaBancariaForm)
    },
    {
        path: '/cuentasbancarias/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('cuentasbancarias/edit', [], CuentaBancariaForm)
    },
    {
        path: '/cuentasbancarias/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('cuentasbancarias/view', [], CuentaBancariaForm, { editable: false })
    },
];
export default routes;